$('[data-toggle-alert-mobile]').on('click', function(){
    var alertContent = $(this).parents('.alert').find('[data-alert-content]');
    alertContent.toggleClass('is-active');

    if(alertContent.hasClass('is-active')){
        $(this).attr('aria-expanded', true);
    } else {
        $(this).attr('aria-expanded', false);
    }
});